import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  getOfferResponseById,
  downloadFile,
  updateOfferResponse,
} from "../../modules/actions";
import { getRequestById } from "../../../OfferRequests/modules/actions";

const mapStateToProps = (state) => ({
  state: {
    currentOfferResponse: state.offerResponseReducer.currentOfferResponse,
    currentOfferRequest: state.offerRequestReducer.currentOfferRequest,
  },
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getOfferResponseById,
      downloadFile,
      getRequestById,
      updateOfferResponse,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
